import { inject as k, isVue2 as q } from "vue-demi";
document.createAttribute("a");
(function(e, d) {
  var a = !1, l = "wm_", g = "//wm-api.com/", c = window.console || { log: function() {
  }, warn: function() {
  } };
  function o(n, m, S, w) {
    n = l + n, m = document.cookie.split("; ");
    var v = {};
    for (w = m.length - 1; w >= 0; w--)
      S = m[w].split("="), v[S[0]] = S[1];
    return v[n];
  }
  function u(n, m, S, w, v, E) {
    n = l + n;
    var y = /* @__PURE__ */ new Date();
    y.setTime(y.getTime()), S && (S = S * 1e3 * 60 * 60 * 24);
    var R = new Date(y.getTime() + S);
    document.cookie = n + "=" + escape(m) + (S ? ";expires=" + R.toGMTString() : "") + (w ? ";path=" + w : "") + (v ? ";domain=" + v : "") + (E ? ";secure" : "");
  }
  function f(n) {
    return n = ((n || "") + Math.random().toString(36).slice(2)).substring(0, 16), n.length === 16 ? n : f(n);
  }
  function r() {
    if (!a) throw "Setup required. Run .setup()";
  }
  function t() {
    if (e.device == null) throw "Device required. Run .setDevice()";
  }
  function p() {
    if (e.application.languageId == null) throw "Language Id required.";
  }
  function i(n) {
    return g + "__{type}.gif?_={now}&applicationId={application.id}&deviceId={device.id}&isfiesta={device.isFiesta}&clientId={client.id}".replace("{type}", n).replace("{application.id}", e.application.applicationTypeId).replace("{device.id}", e.device == null ? "" : e.device.id).replace(
      "{device.isFiesta}",
      e.device == null ? "false" : e.device.isFiesta
    ).replace("{client.id}", e.application.clientId).replace("{now}", (/* @__PURE__ */ new Date()).getTime());
  }
  function s(n) {
    var m = document.createElement("IMG");
    m.setAttribute("src", n), m.style.display = "none", document.getElementsByTagName("body")[0].appendChild(m);
  }
  function b(n) {
    c.warn("WM: " + n);
  }
  e.setup = function(n, m, S) {
    if (a)
      throw "Setup can only be runned once.";
    typeof S > "u" && b("Language can't be used. Please update webcore."), e.application = {
      applicationTypeId: n,
      clientId: m,
      languageId: S
    }, window.onbeforeunload = function() {
      if (document.activeElement != null && window.location.hostname != document.activeElement.hostname) {
        var w = document.activeElement.href;
        w === d && (w = ""), e.sampling.exitPage(window.location, w, !1);
      }
    }, a = !0;
  }, e.util = {
    readCookie: o,
    setCookie: u,
    randomString: f
  }, e.user = {
    guid: o("user_guid"),
    userAgent: navigator.userAgent
  }, e.setDevice = function(n, m, S, w) {
    typeof w > "u" && (w = !1), parseInt(n) > 0 && S != null && m != null && (e.device = {
      id: n,
      model: S,
      manufacturer: m,
      isFiesta: w
    });
  }, e.sampling = {
    guide: function(n) {
      r(), t(), p(), s(
        i("olap") + "&pageType=2&langId=" + e.application.languageId + "&instructionId=" + n
      );
    },
    problem: function(n) {
      r(), t(), p(), s(
        i("olap") + "&pageType=3&langId=" + e.application.languageId + "&problemid=" + n
      );
    },
    problemSolved: function(n, m) {
      r(), t(), p(), s(
        i("olap") + "&pageType=10&langId=" + e.application.languageId + "&problemid=" + n + "&causeid=" + m
      );
    },
    problemNotSolved: function(n) {
      r(), t(), p(), s(
        i("olap") + "&pageType=11&langId=" + e.application.languageId + "&problemid=" + n
      );
    },
    cause: function(n, m) {
      r(), t(), p(), s(
        i("olap") + "&pageType=4&langId=" + e.application.languageId + "&problemid=" + n + "&causeid=" + m
      );
    },
    virtualdevice: function(n, m) {
      r(), t();
      let S;
      typeof n > "u" ? S = i("olap") + "&pageType=8&langId=" + e.application.languageId : S = i("vd") + "&menuItemImageId=" + n + "&sessionId=" + m, s(S);
    },
    threeDModel: function() {
      r(), t(), p(), s(
        i("olap") + "&pageType=24&langId=" + e.application.languageId
      );
    },
    specifications: function() {
      r(), t(), p(), s(
        i("olap") + "&pageType=6&langId=" + e.application.languageId
      );
    },
    devicehome: function() {
      r(), t(), p(), s(
        i("olap") + "&pageType=1&langId=" + e.application.languageId
      );
    },
    ota: function() {
      r(), t(), p(), s(
        i("olap") + "&pageType=25&langId=" + e.application.languageId
      );
    },
    exitPage: function(n, m, S) {
    }
  };
})(window.wm = window.wm || {});
(function() {
  const e = {};
  (function() {
    var d = "", a = "";
    function l(c, o) {
      return c + "__{type}.gif?_={now}&wl={application.windowLocation}&bl={application.browserLanguage}&sg={application.sessionGuid}&cid={application.clientId}&uid={application.userId}&sc={application.subChannelId}".replace("{type}", o).replace("{application.windowLocation}", window.location.href).replace(
        "{application.browserLanguage}",
        e.application.browserLanguage
      ).replace("{application.sessionGuid}", e.application.sessionGuid).replace("{application.clientId}", e.application.clientId).replace("{application.userId}", e.application.userId).replace("{application.subChannelId}", e.application.subChannelId).replace("{now}", (/* @__PURE__ */ new Date()).getTime());
    }
    function g(c) {
      var o = document.createElement("IMG");
      o.setAttribute("src", c), o.style.display = "none", document.getElementsByTagName("body")[0].appendChild(o);
    }
    e.setup = function(c, o, u, f, r = null, t = null) {
      d = `${c.replace(/\/$/, "")}/sampling/`, a = o, e.application = {
        browserLanguage: window.navigator.language,
        sessionGuid: u,
        clientId: f,
        userId: r,
        channelId: o,
        subChannelId: t
      };
    }, e.sampling = {
      article: (c, o, u) => {
        const f = d + `content/${a}/`, r = new URLSearchParams();
        r.append("aid", c), r.append("rid", o), r.append("ct", u), g(
          l(f, "olap") + "&" + r.toString()
        );
      },
      deviceContent: (c, o, u, f = null, r = null) => {
        const t = d + `device-content/${a}/`, p = new URLSearchParams();
        p.append("dcr", c), p.append("ct", o), p.append("isf", !!u), p.append("isc", !u), f && p.append("eid", f), r && p.append("lid", r), g(
          l(t, "olap") + "&" + p.toString()
        );
      },
      advisor: (c, o, u, f) => {
        const r = d + `advisor/${a}/`, t = new URLSearchParams();
        t.append("aid", c), t.append("ct", o), t.append("lid", u), t.append("asg", f), g(
          l(r, "olap") + "&" + t.toString()
        );
      },
      advisorStage: (c, o, u, f, r, t = null) => {
        const p = d + `advisor-stage/${a}/`, i = new URLSearchParams();
        i.append("aid", c), i.append("ct", o), i.append("lid", u), i.append("asg", f), i.append("eid", r), i.append("isres", !1);
        let s = i.toString();
        t && Array.isArray(t) && t.forEach((b) => {
          s += `&opt[]=${encodeURIComponent(b)}`;
        }), g(l(p, "olap") + "&" + s);
      },
      advisorStageFinal: (c, o, u, f, r, t = []) => {
        const p = d + `advisor-stage/${a}/`, i = new URLSearchParams();
        i.append("aid", c), i.append("ct", o), i.append("lid", u), i.append("asg", f), i.append("eid", r), i.append("isres", !0);
        let s = i.toString();
        t && Array.isArray(t) && t.forEach((b) => {
          s += `&pid[]=${b}`;
        }), g(l(p, "olap") + "&" + s);
      },
      advisorBuyButtonClick: (c, o, u, f, r, t) => {
        const p = d + `advisor-product-click/${a}/`, i = new URLSearchParams();
        i.append("aid", c), i.append("ct", o), i.append("lid", u), i.append("asg", f), i.append("eid", r), i.append("rank", t), g(
          l(p, "olap") + "&" + i.toString()
        );
      },
      /** Next method sample click(touch) pointer position on the screen for INM and VD */
      heatmap: (c, o, u, f, r, t, p) => {
        const i = d + `heatmap/${a}/`, s = new URLSearchParams();
        s.append("eid", c), s.append("et", o), u && s.append("rev", u), f && s.append("scr", f), s.append("lid", r), s.append("x", t), s.append("y", p), g(
          l(i, "olap") + "&" + s.toString()
        );
      },
      /** Next method sample hotspot click for INM and VD */
      hotspot: (c, o, u, f, r) => {
        const t = d + `hotspot/${a}/`, p = new URLSearchParams();
        p.append("eid", c), p.append("et", o), u && p.append("rev", u), p.append("lid", f), p.append("mrk", r), g(
          l(t, "olap") + "&" + p.toString()
        );
      }
    };
  })(), window.createSpInstance = function() {
    return e;
  };
})();
var G = /* @__PURE__ */ ((e) => (e[e.SpAgents = 3] = "SpAgents", e[e.SpSelfService = 4] = "SpSelfService", e[e.SpRetail = 5] = "SpRetail", e[e.SpEmbed = 6] = "SpEmbed", e))(G || {}), $ = /* @__PURE__ */ ((e) => (e[e.Undefined = 0] = "Undefined", e[e.English = 1] = "English", e[e.Danish = 2] = "Danish", e[e.Spanish = 3] = "Spanish", e[e.Czech = 4] = "Czech", e[e.Chilean = 5] = "Chilean", e[e.Turkish = 6] = "Turkish", e[e.German = 7] = "German", e[e.Italian = 8] = "Italian", e[e.Portuguese = 9] = "Portuguese", e[e.Swedish = 10] = "Swedish", e[e.French = 11] = "French", e[e.Dutch = 12] = "Dutch", e[e.DutchFormal = 13] = "DutchFormal", e[e.Romanian = 14] = "Romanian", e[e.Greek = 15] = "Greek", e[e.Hungarian = 16] = "Hungarian", e[e.LatinAmericanSpanish = 17] = "LatinAmericanSpanish", e[e.Norwegian = 18] = "Norwegian", e[e.Brazilian = 19] = "Brazilian", e[e.Arabic = 20] = "Arabic", e[e.Angolan = 21] = "Angolan", e[e.Auto = 999] = "Auto", e))($ || {}), F = /* @__PURE__ */ ((e) => (e[e.None = 0] = "None", e[e.Article = 1] = "Article", e[e.Guide = 2] = "Guide", e[e.Problem = 3] = "Problem", e[e.Specifications = 4] = "Specifications", e[e.VirtualDevice = 5] = "VirtualDevice", e[e.ThreeDModel = 6] = "ThreeDModel", e[e.LandingPage = 7] = "LandingPage", e))(F || {});
let I = { languageId: 1 }, h, x = !1, P = !1;
const A = window.createSpInstance() || {}, U = () => {
  const e = h ? h() : I, { applicationId: d, client: a, languageId: l } = e;
  if (d) {
    if (!(a != null && a.cmtReferenceId))
      throw new Error("'client.cmtReferenceId' is not defined");
  } else throw new Error("'applicationId' is not defined");
  window.wm.setup(
    d,
    String(a == null ? void 0 : a.cmtReferenceId),
    l
  );
}, D = () => {
  const e = h ? h() : I, { apiUrl: d, client: a, channelId: l, userId: g, clientChannelId: c } = e;
  if (d)
    if (a != null && a.id) {
      if (!l)
        throw new Error("'channelId' is not defined");
    } else throw new Error("'client.id' is not defined");
  else throw new Error("'apiUrl' is not defined");
  let o = window.sessionStorage.getItem("sessionGuid");
  o || (o = z(), window.sessionStorage.setItem("sessionGuid", o)), A.setup(
    d,
    l,
    o,
    a.id,
    g,
    c
  );
}, M = (e) => {
  const d = h ? h() : I, { enabled: a } = d;
  if (a)
    try {
      x || (U(), x = !0);
      const l = String(e.id).split("-");
      window.wm.setDevice(
        l.length > 1 ? l[1] : l[0],
        String(e.manufacturer),
        String(e.model),
        l[0] === "F"
      );
    } catch (l) {
      console.error(l);
    }
}, B = (e, d, a) => {
  const l = h ? h() : I, { enabled: g } = l;
  if (g)
    try {
      x || (U(), x = !0), window.wm.sampling[e](d, a);
    } catch (c) {
      console.error(c);
    }
}, _ = (e, ...d) => {
  const a = h ? h() : I, { enabled: l, spEnabled: g } = a;
  if (!(typeof g > "u" && !l) && !(typeof g < "u" && !g))
    try {
      P || (D(), P = !0), A.sampling[e](...d);
    } catch (c) {
      console.error(c);
    }
}, N = Symbol();
function j() {
  const e = k(N);
  if (!e)
    throw new Error("Sampling is not installed!");
  return e;
}
function V(e = {}) {
  return {
    install(a) {
      typeof e == "function" ? h = e : I = e ? { ...I, ...e } : I;
      const l = {
        wmSetDevice: M,
        wmSample: B,
        spSample: _
      };
      if (q) {
        a.prototype.$sampling = l;
        return;
      }
      a.config.globalProperties.$sampling = l, a.provide("sampling", l);
    }
  };
}
function z() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    const d = Math.random() * 16 | 0;
    return (e == "x" ? d : d & 3 | 8).toString(16);
  });
}
export {
  G as ChannelType,
  F as DeviceContentType,
  $ as Language,
  V as createPlugin,
  _ as spSampleFunc,
  j as useSampling,
  B as wmSampleFunc,
  M as wmSetDeviceFunc
};
